import $ from 'jquery';
import moment from "moment-timezone";

export default {

    indicator:      document.getElementById('user-notification-count-indicator'),
    header:         document.getElementById('user-notification-count'),
    body:           document.getElementById('user-notification-list'),
    readAll:        document.getElementById('user-notification-read-all'),

    notifications:  [],

    init() {

        // skip if there is no element to work with
        if(!this.readAll) {
            return;
        }

        if(this.readAll) {
            // add a listener for the read all button
            this.readAll.addEventListener("click", () => {
                fetch(Syn.generateURL('api_notification_get_collection_read_all', {
                    'isRead': false
                }))
                    .then(response => {
                        if(response.ok) {
                            $(this.body).children('.list-group-item').slideUp();

                            this.notifications = [];
                            this.updateViews();
                        }
                    });
            });
        }

        // get the unread notifications
        fetch(Syn.generateURL('api_notification_get_collection', {
            'isRead':  false,
        }))
            .then(response => {
                if(!response.ok) {
                    console.error('Could not retrieve notifications');
                    return false;
                }

                return response.json();
            })
            .then(data => {
                if(Array.isArray(data["member"])) {
                    this.notifications = data["member"];
                    this.updateViews();

                    this.notifications.forEach(notification => {
                        $(this.body).append(this.renderNotification(notification))
                    });
                }
            });

        Syn.libs.Notifications = this;
    },

    updateViews() {
        this.indicator.innerText    = this.notifications.length;
        this.header.innerText       = Syn.trans('new_notifications', {'notifications': this.notifications.length}, 'SyndustryCommonBundle');

        if(this.notifications.length > 0) {
            this.indicator.classList.remove('d-none');
        } else {
            this.indicator.classList.add('d-none');
            this.readAll.parentNode.classList.add('d-none');
        }
    },

    onNotificationRead(event, notification) {
        fetch(Syn.generateURL('api_notification_patch_item', {
                'id':    notification.id
            }), {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/merge-patch+json',
                },
                body: JSON.stringify({
                    'isRead': true
                }),
            })
            .then(response => {
                if (response.ok) {
                    $(event.target).closest('.list-group-item').slideUp();
                    let index = this.notifications.findIndex(note => note.id == notification.id);
                    this.notifications.splice(index, 1);
                    this.updateViews();
                }
            });
    },

    renderNotification(notification) {
        const iconClass = String(notification.iconClass || '').replace(/^fa-/, '');

        return $('<div>')
            .data('uuid', notification.id)
            .addClass('list-group-item py-0 px-1')
            .append(
                $('<div>')
                    .addClass('row g-0 py-3 align-items-center')
                    .append(
                        $('<div>')
                            .addClass('col-2 text-center')
                            .html($('<i/>').addClass('fa fa-' + iconClass + ' text-' + notification.themeClass)),
                        $('<a>')
                            .addClass('col-8')
                            .attr('href', Syn.generateURL('notifications_show', { 'id': notification.id }))
                            .css('text-decoration', 'none')
                            .append(
                                $('<span>').addClass('d-block').html(notification.subject),
                                $('<span>').addClass('d-block text-muted small mt-1').html(
                                    moment.tz(notification.createdAt, 'UTC').fromNow()
                                ),
                            ),
                        $('<div>')
                            .addClass('col-2 text-center')
                            .html(
                                $('<button>')
                                    .attr('type', 'button')
                                    .addClass('btn btn-outline-success btn-circle')
                                    .on('click', (event) => this.onNotificationRead(event, notification))
                                    .html($('<i/>').addClass('fa fa-check'))
                            )
                    )
        );
    }
}
